import { render, staticRenderFns } from "./duoTrainingModulePage.vue?vue&type=template&id=003882a7&"
import script from "./duoTrainingModulePage.vue?vue&type=script&lang=js&"
export * from "./duoTrainingModulePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports